<style scoped="scoped" lang="scss"></style>

<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt"  getUrl="/web/production/erpwo/page" getKey="rows"
			:columns="columns">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item :label="$t('ERPgongdanhao')">
						<el-input v-model="yt.conditions.no"></el-input>
					</el-form-item>
					<el-form-item :label="$t('chanpinbianma')">
						<el-input v-model="yt.conditions.materialCode"></el-input>
					</el-form-item>
					<el-form-item :label="$t('chanpinmingcheng')">
						<el-input v-model="yt.conditions.materialName"></el-input>
					</el-form-item>
					<el-form-item :label="$t('jihuakaishishijian')">
						<yi_time_input type="datetimerange"
							:start.sync="yt.conditions.startTime" :end.sync="yt.conditions.endTime"
							:placeholder="$t('xuanzeriqiheshijian')">
						</yi_time_input>
					</el-form-item>
					<el-form-item>
						<el-button @click="yt.get(1)" type="primary" plain="plain">
							{{$t('sousuo')}}
						</el-button>
						<el-button @click="yt.clear()">{{$t('chongzhi')}}</el-button>
						<yi_curd_expand_button></yi_curd_expand_button>
					</el-form-item>
				</el-form>
			</template>
			<!-- 右侧按钮插槽 -->
			<template #buttonsR>
				<el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"  @click="yt.showColumnsDialog()"></el-button>
			</template>
			<!-- 操作插槽 -->
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button type="text" @click="yt.showEditDialog('chakangongdanBOM', scope.row,'w2')">{{$t('chakangongdanBOM')}}</el-button>
					</el-col>
				</el-row>
			</template>
		</yi_curd_table>

		<!-- 新增/编辑弹框 -->
		<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
			:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
	
			<!-- 查看工单BOM -->
			<template v-if="yt.editObj.action == 'chakangongdanBOM'">
				<div class="dialog-scroller">
					<work_bom :bom="yt.editObj"></work_bom>
				</div>
			</template>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	import work_bom from '@@/pages/web/order_management/erp/work_bom'
	export default {
		name: 'web_order_management_erp_list',
		components: {
			work_bom
		},
		data() {
			return {
				columns: [{
					label: 'ERPgongdanhao',
					prop: 'no',
					width: 130
				}, {
					label: 'chanpinbianma',
					prop: 'materialCode',
					width: 130
				}, {
					label: 'chanpinmingcheng',
					prop: 'materialName'
				}, 
				{
					label: 'jihuashuliang',
					prop: 'quantity'
				},
				{
					label: 'yishengchanshuliang',
					prop: 'name'
				},  {
					label: 'danwei',
					prop: 'unit'
				}, {
					label: 'guishuchejian',
					prop: 'org.name'
				},{
					label: 'zhuangtai',
					prop: 'status'
				},{
					label: 'jihuakaishishijian',
					prop: 'startTime',
					type: 'time',
				},{
					label: 'jihuawanchengshijian',
					prop: 'endTime',
					type: 'time',
				},{
					label: 'shijikaishishijian',
					prop: 'actualStartTime',
					type: 'time',
				}, {
					label: 'shijiwanchengshijian',
					prop: 'actualEndTime',
					type: 'time',
				},{
					label: 'beizhu',
					prop: 'remark',
				},{
					label: 'caozuo',
					type: 'slot',
					width: 130,
					fixed: 'right'
				}]
			};
		},

		created() {
			setTimeout(() => {
				this.yt.get(1)
			}, 300)
		},
		methods: {
		
		}
	};
</script>
